<template>
    <section class="quiz" id="quiz">
        <div class="quiz__container">
            <div class="quiz__question" v-if="!showFeedback">
                <div v-html="currentQuestion.question" class="rte"></div>
                <ul class="quiz__question__answers" v-bind:class="{'answered' : answered}">
                    <li class="quiz__question__answer" v-bind:class="{correct : (answered && answer.isCorrectAnswer && !quiz.hideAnswerResult), selected : selectedAnswer == index}" v-for="(answer,index) in currentQuestion.answers" v-on:click="answerQuestion(answer.isCorrectAnswer,index, answer)" :key="answer.answer">
                        {{ answer.answer }} <span v-if="answered && answer.hasPercentageAnswered">{{ answer.percentageAnswered}} %</span>
                    </li>
                </ul>
                <div class="quiz__question__result" v-bind:class="[correct ? 'correct' : 'false']" v-if="answered && !quiz.hideAnswerResult">{{ correct ? 'Korrekt' : 'Forkert' }}</div>
                <div class="quiz__question__feedback rte" v-html="feedBack(uniqueAnswerFeedback, currentQuestion.feedback)" v-if="answered"></div>
                <div class="quiz__controls">
                    <button v-on:click="nextQuestion" v-if="answered">
                        {{ questionIndex + 1 == numberOfQuestions ? 'Afslut' : 'Næste spørgsmål' }}
                    </button>
                </div>
            </div>
            <div class="quiz__response" v-if="showFeedback">
                <div class="rte" v-html="quizResponse.response"></div>
                <div class="quiz__controls" v-if="!quiz.hideStartOver">
                    <button v-on:click="resetQuiz">Start forfra</button>
                </div>
                <div class="fb-share-button" v-if="!quiz.hidehideShareOnFacebook" :data-href="url" data-layout="button" data-size="large">
                    <a target="_blank" :href="facebookShareUrl" class="fb-xfbml-parse-ignore">Del på Facebook</a>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "quiz",
        data() {
            return {
                quiz: null,
                questionIndex: 0,
                answered: false,
                correct: false,
                numberOfCorrectAnswers: 0,
                showFeedback: false,
                url: "",
                selectedAnswer: null,
                uniqueAnswerFeedback: ""
            };
        },
        created() {
            console.log(this.$parent.vm);
            this.quiz = JSON.parse(this.$parent.vm);
            this.url = this.$parent.url;
        },
        methods: {
            nextQuestion() {
                this.answered = false;
                this.uniqueAnswerFeedback = "";
                if (this.questionIndex + 1 != this.numberOfQuestions) {
                    this.questionIndex++;
                    this.selectedAnswer = null;
                } else {
                    this.showFeedback = true;
                }

                var container = this.$el;
                var headerOffset = document.getElementsByTagName("header")[0].offsetHeight;
                window.scrollTo(0, container.offsetTop - headerOffset - 15);
            },
            answerQuestion(isCorrect, index, answer) {
                if (this.answered) return false;

                this.correct = isCorrect;
                if (isCorrect) this.numberOfCorrectAnswers++;
                this.selectedAnswer = index;
                this.answered = true;
                this.uniqueAnswerFeedback = answer.uniqueAnswerFeedback;
            },
            resetQuiz() {
                this.showFeedback = false;
                this.numberOfCorrectAnswers = 0;
                this.questionIndex = 0;
                this.selectedAnswer = null;
            },
            feedBack: function (uniquefeedback, normalFeedback) {
                return uniquefeedback.length ? uniquefeedback : normalFeedback;
            },
        },
        computed: {
            currentQuestion: function () {
                return this.quiz.questions[this.questionIndex];
            },
            correctPercentage: function () {
                return (this.numberOfCorrectAnswers / this.numberOfQuestions) * 100;
            },
            numberOfQuestions: function () {
                return this.quiz.questions.length;
            },
            quizResponse: function () {
                if (this.quiz.responses.length == 1) return this.quiz.responses[0];

                for (var i = 0; i < this.quiz.responses.length; i++) {
                    var current = this.quiz.responses[i];

                    if (this.correctPercentage >= current.percentageRight) {
                        return current;
                    }
                }
            },
            facebookShareUrl: function () {
                return "https://www.facebook.com/sharer/sharer.php?u=" + encodeURI(this.url) + "&amp;src=sdkpreparse";
            }
        }
    };
</script>